import React from "react";
import styles from "./ApiKeyTab.module.scss";
import { Box, MoveHorizontal } from "lucide-react";
import logo from "../../assets/images/swan.svg";

interface ApiKeyTabProps {
	title: string;
	description: string;
	children: React.ReactNode;
	showOverview?: boolean;
}

const ApiKeyTab = ({ title, description, children, showOverview = true }: ApiKeyTabProps) => {
	return (
		<div className={`${styles.apiKeyTab}`}>
			{showOverview ? <>
			<h2>{title}</h2>
			<div className={`${styles.apiKeyTab__empty}`}>
				<div className={`${styles.apiKeyTab__arrow} flex align-center justify-center`}>
					<span>
						<Box />
					</span>
					<MoveHorizontal />
					<span>
				<img src={logo} alt="swan" />
					</span>
				</div>

				<p>{description}</p>
				{children}
			</div>
			</> : <div className={`${styles.apiKeyTab__table} flex justify-between align-center`}>
				<aside>
					<h2>{title}</h2>
					<p>{description}</p>
				</aside>
				{children}
			</div>}
			
		</div>
	);
};
export default ApiKeyTab;
